// import { Observable } from 'rxjs';
// import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
// import { Router } from '@angular/router';
// import { NewsMediaService } from '../services/news-media.service';
// import { PublicationsService } from './../services/publications.service';
// import { TeamsService } from '../services/teams.service';
// import { PartnersSponsershipService } from '../services/partners-sponsership.service';
// import { PopupModalComponent } from './../shared/popup-modal/popup-modal.component'; // 팝업 모달 컴포넌트 추가 02/19/25


// declare var TweenLite, TweenMax, TimelineMax, Ease, Expo, ScrollMagic, Power2 :any;

// import { WINDOW } from "../services/window.service";



// @Component({
//   selector: 'app-home',
//   templateUrl: './home.component.html',
//   styleUrls: ['./home.component.scss']
// })
// export class HomeComponent implements OnInit, AfterViewInit {

//   @ViewChild('popup') popup: PopupModalComponent; // 02/19/25
//   public imgPath:string = "./../../assets/Contents/";
//   public defaultImage = "./../../assets/Contents/imgs/no_image.jpg";

//   issues: Observable<any[]>;
//   publications$: Observable<any[]>;
//   teams$: Observable<any[]>;
//   partners$: Observable<any[]>;

//   constructor(
//     private newsMediaService: NewsMediaService,
//     private publicationsService:PublicationsService,
//     private partnersSponsershipService:PartnersSponsershipService,
//     private teamsService: TeamsService,
//     private el:ElementRef,
//     private router:Router,
//     @Inject(WINDOW) private window: Window
//     ) { 
//   }

//   ngOnInit() {
//     this.setScrollMagic();
//     this.arrowMove();
//     this.issues = this.newsMediaService.findAllIssues();
//     this.publications$ = this.publicationsService.findPublicationsForHome('international');
//     this.teams$ = this.teamsService.findAllTeams();
//     this.partners$ = this.partnersSponsershipService.findMainPartner();
//   }

//   // 02/19/25 added
//   ngAfterViewInit() {
//     setTimeout(() => {
//       if (this.popup) {
//         this.popup.open();  // ✅ 페이지가 열릴 때 팝업 자동 실행
//       }
//     }, 500);  // 0.5초 후 실행 (렌더링 문제 방지)
//   }

//   arrowMove() {
//     let arrowBtn = document.getElementById("arrowBtn");
//     var tl = new TimelineMax({repeat:20});
//     tl.to(arrowBtn, 0.7, {y:30})
//       .to(arrowBtn, 1, {y:0})
//   }


//   setScrollMagic() {
//     const controller = new ScrollMagic.Controller();
//     const navigation_tween = new TimelineMax()
//       .to('#logo-animation',0.15, {filter: 'contrast(1) brightness(1)'})
//       .set('.menu_btn', {color:'#F05A29'})
//       .set('#nav-animation', { boxShadow: '0 1.5px 4px rgba(0, 0, 0, 0.24), 0 1.5px 6px rgba(0, 0, 0, 0.12)'})
//       .to('#nav-animation', 0.15, { backgroundColor:'white'})
//       .to('.nav-item a', 0.3, {color:'#262626'})

//     const title_tween = TweenLite.to('.title', 0.5, {
//       opacity: 0
//     })

//     const nav_scene = new ScrollMagic.Scene({
//       triggerElement: '#nav-trigger'
//     })
//       .setTween([navigation_tween, title_tween]);

//     controller.addScene([
//       nav_scene
//     ]);
//   }

//   navigateTo(id, arg = 0) {
//     if (arg == 0) {
//       this.router.navigate(['/main/area/teams', id])
//     } else if (arg == 1) {
//       this.router.navigate(['/main/international/individual', id]);
//     } else if (arg ==2) {
//         if ( id == 'news') {
//           this.router.navigate(['/main/news'])
//         } else if (id== 'media') {
//           this.router.navigate(['/main/media'])
//         } else {
//           this.router.navigate(['/main/news'])
//         }
//     }
//   }

//   moveTo(id) {
//     // console.log(id);
//     // var controller = new ScrollMagic.Controller();
//     // var scene = new ScrollMagic.Scene({triggerElement: "a#top", duration: 200, triggerHook: "onLeave"})
//     //             .addTo(controller);
//     var new_id = '#' + id + 'Place';
//     // controller.scrollTo(new_id);
//     // TweenLite.to(document.body, 1.3, {scrollTo:{y:new_id}, ease:Power2.easeOut})
//     // TweenLite.to(document.body, 1, {scrollTop: 200});
//   }
// }




import { Observable } from 'rxjs';
import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { NewsMediaService } from '../services/news-media.service';
import { PublicationsService } from './../services/publications.service';
import { TeamsService } from '../services/teams.service';
import { PartnersSponsershipService } from '../services/partners-sponsership.service';
import { PopupModalComponent } from './../shared/popup-modal/popup-modal.component'; // 팝업 모달 컴포넌트 추가 02/19/25
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'; // 팝업을 제어할 모달 서비스 추가

declare var TweenLite, TweenMax, TimelineMax, Ease, Expo, ScrollMagic, Power2: any;

import { WINDOW } from "../services/window.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  @ViewChild('popup') popup: PopupModalComponent; // 02/19/25
  public imgPath: string = "./../../assets/Contents/";
  public defaultImage = "./../../assets/Contents/imgs/no_image.jpg";

  issues: Observable<any[]>;
  publications$: Observable<any[]>;
  teams$: Observable<any[]>;
  partners$: Observable<any[]>;

  constructor(
    private newsMediaService: NewsMediaService,
    private publicationsService: PublicationsService,
    private partnersSponsershipService: PartnersSponsershipService,
    private teamsService: TeamsService,
    private el: ElementRef,
    private router: Router,
    private modalService: NgbModal, // 팝업을 위한 모달 서비스 추가\
    
    @Inject(WINDOW) private window: Window
  ) { 
    console.log('🛠️ HomeComponent Constructor 실행됨');
  }

  ngOnInit() {
    console.log('✅ ngOnInit() 실행됨 - HomeComponent 로드됨');
    this.setScrollMagic();
    this.arrowMove();
    this.issues = this.newsMediaService.findAllIssues();
    this.publications$ = this.publicationsService.findPublicationsForHome('international');
    this.teams$ = this.teamsService.findAllTeams();
    this.partners$ = this.partnersSponsershipService.findMainPartner();
  }

  // 02/19/25 added
  ngAfterViewInit() {
    console.log('📢 ngAfterViewInit() 실행됨 - UI 렌더링 완료');
    setTimeout(() => {
      try {
        console.log('🛠️ 팝업 모달 열기 시도');
        this.openPopup(); // ✅ 페이지가 열릴 때 팝업 실행
      } catch (error) {
        console.error('❌ 팝업 실행 중 오류 발생:', error);
      }
    }, 500);  // 0.5초 후 실행 (렌더링 문제 방지)
  }

  // ✅ 팝업 실행 함수 추가
  openPopup() {
    console.log('📢 openPopup() 실행됨');
    const modalRef = this.modalService.open(PopupModalComponent);
    modalRef.result.then(
      () => console.log('✅ 팝업 닫힘'),
      () => console.log('❌ 팝업이 비정상적으로 닫힘')
    );
  }

  arrowMove() {
    console.log('➡️ arrowMove() 실행됨');
    let arrowBtn = document.getElementById("arrowBtn");
    var tl = new TimelineMax({ repeat: 20 });
    tl.to(arrowBtn, 0.7, { y: 30 })
      .to(arrowBtn, 1, { y: 0 })
  }

  setScrollMagic() {
    console.log('📜 setScrollMagic() 실행됨');
    const controller = new ScrollMagic.Controller();
    const navigation_tween = new TimelineMax()
      .to('#logo-animation', 0.15, { filter: 'contrast(1) brightness(1)' })
      .set('.menu_btn', { color: '#F05A29' })
      .set('#nav-animation', { boxShadow: '0 1.5px 4px rgba(0, 0, 0, 0.24), 0 1.5px 6px rgba(0, 0, 0, 0.12)' })
      .to('#nav-animation', 0.15, { backgroundColor: 'white' })
      .to('.nav-item a', 0.3, { color: '#262626' });

    const title_tween = TweenLite.to('.title', 0.5, {
      opacity: 0
    });

    const nav_scene = new ScrollMagic.Scene({
      triggerElement: '#nav-trigger'
    })
      .setTween([navigation_tween, title_tween]);

    controller.addScene([
      nav_scene
    ]);
  }

  navigateTo(id, arg = 0) {
    console.log(`🚀 navigateTo(${id}, ${arg}) 실행됨`);
    if (arg == 0) {
      this.router.navigate(['/main/area/teams', id])
    } else if (arg == 1) {
      this.router.navigate(['/main/international/individual', id]);
    } else if (arg == 2) {
      if (id == 'news') {
        this.router.navigate(['/main/news'])
      } else if (id == 'media') {
        this.router.navigate(['/main/media'])
      } else {
        this.router.navigate(['/main/news'])
      }
    }
  }

  moveTo(id) {
    console.log(`📍 moveTo(${id}) 실행됨`);
    var new_id = '#' + id + 'Place';
  }
}




// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/home/home.component.ts